<template>
	<div class="closed-beta-bar">
		<h2 class="closed-beta-title">
			Currently closed Beta. Early access available.
		</h2>
	</div>
</template>

<script>
export default {
	name: 'TheBetaBar',
};
</script>

<style lang="scss" scoped>
.closed-beta-bar {
	width: 100%;
	height: 32px;
	background-color: $color-warning;
	display: flex;
	align-items: center;
	justify-content: center;
	color: $color-white;
}

.closed-beta-title {
	font-size: $size-7;
	font-weight: $fontWeight-bold;
}
</style>
